import PropTypes from 'prop-types'

import Text from 'components/common/Text'

export function getMaxRunsVerbiage(amount) {
  return Number(amount) === 1 ? 'once a day' : `${amount} times a day`
}

export default function MaxRuns({ amount, ...rest }) {
  return (
    <Text as="small" {...rest}>
      {getMaxRunsVerbiage(amount)}
    </Text>
  )
}

MaxRuns.propTypes = {
  amount: PropTypes.number
}
